import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { useCurrentUser } from '../hooks/useCurrentUser';
import Spinner from '../components/ui/Spinner';

/**
 * Route guard for the super-admin portal: requires a session AND
 * `user.role === 'super_admin'`. UX-only — the backend re-checks the role from
 * the database on every /admin request. Unauthenticated visitors go to the
 * portal's own login page.
 */
export default function RoleRoute({ role = 'super_admin', children }) {
  const isAuthenticated = useAuthStore((s) => Boolean(s.accessToken));
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  // Keeps the persisted user fresh so a role change is picked up on reload.
  const { isLoading } = useCurrentUser();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!user && isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner label="Checking access…" />
      </div>
    );
  }
  if (user?.role !== role) {
    return <Navigate to="/files" replace />;
  }
  return children;
}
